export const enTexts = {
  message: {
    hello: "hello world"
  }
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/languages/en.ts